import { Metadata } from 'next'

const title = 'Give the Gift of Stress-Free Travel | Ship&Play'
const description =
  'Treat the travelers in your life to easier journeys. Ship&Play gift cards make the perfect ' +
  'gift for birthdays, holidays, or any special occasion.'
const url = 'https://www.shipplay.com/gift-cards'
const image = 'https://media.shipplay.com/ship-sticks-og-image.png'

const metadata: Metadata = {
  title,
  description,
  alternates: {
    canonical: url,
  },
  openGraph: {
    type: 'website',
    url,
    siteName: 'Ship&Play',
    title,
    description,
    images: [
      {
        url: image,
        width: 1200,
        height: 630,
        alt: 'Ship&Play gift cards — give the gift of stress-free travel',
      },
    ],
  },
  twitter: {
    card: 'summary_large_image',
    title,
    description,
    images: [image],
  },
}

export default metadata
